import { request } from './client.js';
import type { CrossClientResult, Overview } from './types.js';

export function getOverview(clientTenantId: string, idToken: string): Promise<Overview> {
  return request<Overview>('GET', `/tenants/${encodeURIComponent(clientTenantId)}/overview`, idToken);
}

/** Every visible Client, or only those under `org` (task 205). */
export function getCrossClient(
  idToken: string,
  options: { org?: string } = {},
): Promise<CrossClientResult> {
  return request<CrossClientResult>('GET', '/overview/cross-client', idToken, {
    query: { org: options.org },
  });
}
